<template>
  <div class="flashlight-filter">
    <div class="flashlight" id="flashlight"></div>
  </div>
</template>
<script>

  import $ from 'jquery'

  export default {
    name: 'flashlight-background-component',
    mounted() {

      $(document).ready(() => {
        $(window).mousemove(e => {
          let w = $(window).width();
          let h = $(window).height();
          $('#flashlight').css({
            'left': e.clientX - w,
            'top': e.clientY - h
          });
        });
      });
    }
  }
</script>

<style lang="scss">
  .flashlight-filter {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;

    @media (max-width: 992px) {
      display: none;
    }

  }

  .flashlight {
    background: url(https://s3.amazonaws.com/ip-devs/AllState/keep-your-sanity/img/flashlight.png) center center no-repeat;
    background-size: cover;
    position: absolute;
    opacity: .6;
    z-index: 10;
    height: 200vh;
    width: 200vw;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/flashlight-filter.vue